import React, { useEffect, useRef, useState } from 'react';
import { Music, BookOpen, Palette, Puzzle, MessageCircle, Activity } from 'lucide-react';
import { offerings } from '../mock';

const iconMap = {
  music: Music,
  'book-open': BookOpen,
  palette: Palette,
  puzzle: Puzzle,
  'message-circle': MessageCircle,
  activity: Activity
};

const OfferingsSection = () => {
  return (
    <section
      id="offerings"
      className="py-24 relative"
      style={{ background: '#FFFFFF' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Merriweather, serif', color: '#163172' }}
          >
            Choose Your Journey
          </h2>
          <p
            className="text-base md:text-lg max-w-2xl mx-auto"
            style={{ color: '#555555' }}
          >
            Tailored sessions focused on comfort and genuine presence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {offerings.map((offering) => {
            const Icon = iconMap[offering.icon];

            return (
              <div
                key={offering.id}
                className="p-6 rounded-2xl border border-[#D6E4F0] hover:bg-[#F6F6F6] transition-colors duration-200"
              >
                <div className="mb-4">
                  <Icon className="w-6 h-6" style={{ color: '#1E56A0' }} />
                </div>

                <h3 className="text-xl font-bold mb-2" style={{ color: '#163172' }}>
                  {offering.title}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#333333' }}>
                  {offering.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm" style={{ color: '#777777' }}>
            <span className="font-semibold" style={{ color: '#163172' }}>Guidance available.</span> Our volunteers help guide conversations naturally.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OfferingsSection;
